import FileResizer from 'react-image-file-resizer';

export type ResizeOptions = {
  maxWidth: number;
  maxHeight: number;
  format?: 'JPEG' | 'PNG' | 'WEBP';
  quality?: number; // 0-100
  rotation?: number;
  outputType?: 'base64' | 'file' | 'blob';
};

const defaultOptions: Required<
  Pick<ResizeOptions, 'format' | 'quality' | 'rotation' | 'outputType'>
> &
  Pick<ResizeOptions, 'maxWidth' | 'maxHeight'> = {
  maxWidth: 1500,
  maxHeight: 2655,
  format: 'JPEG',
  quality: 90,
  rotation: 0,
  outputType: 'base64'
};

export async function resizeImageFile(
  file: File,
  options?: Partial<ResizeOptions>
): Promise<string | File | Blob> {
  const cfg = { ...defaultOptions, ...(options || {}) };
  return new Promise((resolve) => {
    FileResizer.imageFileResizer(
      file,
      cfg.maxWidth,
      cfg.maxHeight,
      cfg.format,
      cfg.quality,
      cfg.rotation,
      (uri) => resolve(uri as string | File | Blob),
      cfg.outputType
    );
  });
}

export const resizeToBase64 = (file: File): Promise<string> =>
  resizeImageFile(file, { outputType: 'base64' }) as Promise<string>;

async function fetchImageUrlAsFile(imageUrl: string): Promise<File> {
  const response = await fetch(imageUrl, { mode: 'cors' });
  if (!response.ok) {
    throw new Error(`이미지 fetch 실패: ${response.status} ${response.statusText}`);
  }

  const blob = await response.blob();
  const contentType = blob.type || 'image/jpeg';
  const ext = contentType.split('/')[1] || 'jpg';
  return new File([blob], `image.${ext}`, { type: contentType });
}

/**
 * 원격 이미지 URL을 fetch한 뒤 base64(Data URL) 문자열로 변환합니다.
 * - 내부적으로 File로 감싼 뒤 `resizeToBase64`를 사용합니다.
 */
export async function fetchImageUrlToBase64DataUrl(imageUrl: string): Promise<string> {
  const file = await fetchImageUrlAsFile(imageUrl);
  return await resizeToBase64(file);
}
